export default {
  no_storefront_found: {
    title: 'No storefront found',
    description: 'Please create a storefront.',
  },
};
